export {
  colorOptions,
  personalityOptions,
  ambitionOptions,
  beliefOptions,
  seasonOptions,
  historicalFigureOptions,
  favouriteColorOptions,
  animalOptions,
  kindOptions,
  cultureOptions,
  sexOptions,
  defaultAnswers
} from './nameGenerator.constants';

export type { NameGeneratorAnswers } from './nameGenerator.constants';

export { fetchPupNamesForGenerator } from './nameGenerator.api';
export type { PupNameItem } from './nameGenerator.api';

export { useNameGenerator } from './useNameGenerator';
